import script from "./expoundAnswer.vue?vue&type=script&setup=true&lang=js"
export * from "./expoundAnswer.vue?vue&type=script&setup=true&lang=js"

import "./expoundAnswer.vue?vue&type=style&index=0&id=663672a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-663672a6"]])

export default __exports__